import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Button, IconButton } from 'react-toolbox';
import { connect } from 'react-redux';
import RadioButtons from 'components/RadioButtons';
import SimpleInput from 'components/SimpleInput';
import S from 'modal.scss';
import { getPhaseErrors } from '../../../../../../../../../reducers';

class LrrpInfo extends Resetter(Validator(React.Component)) {
  state = {
    rooms: this.props.rooms || [],
    isLeadPresent: this.props.isLeadPresent || '',
    addRoom: false,
    newRoom: '',
    errors: {},
  };

  handleSubmit = () => {
    const checks = { isLeadPresent: true, rooms: true };
    if (!this.validate(checks)) return;
    const { isLeadPresent, rooms } = this.state;
    this.props.updateFormData({ isLeadPresent, rooms, tab: 2 });
  }

  handleIsLeadPresent = value => this.setState({ isLeadPresent: value });

  handleAddRoom = (e) => {
    e.preventDefault();
    this.setState({ addRoom: !this.state.addRoom, newRoom: '' });
  }

  handleNewRoom = e => this.setState({ newRoom: e.target.value });

  handleSaveRoom = (e) => {
    e.preventDefault();
    const { rooms, newRoom } = this.state;
    rooms.push(newRoom);
    this.setState({ newRoom: '', rooms });
  }

  handleDelete = index => (e) => {
    e.preventDefault();
    const rooms = this.state.rooms;
    rooms.splice(index, 1);
    this.setState({ rooms });
  }

  render() {
    const { rooms, isLeadPresent, newRoom, addRoom } = this.state;
    const buttons = [{
      label: 'YES',
      value: 'yes',
    }, {
      label: 'NO',
      value: 'no',
    }];
    const noRooms = !rooms.length;
    let noRoomsText = 'Answer the question above to continue';
    if (isLeadPresent === 'yes') {
      noRoomsText = 'LRRP CHECKLIST MUST BE FILLED OUT MANUALLY';
    } else if (addRoom) {
      noRoomsText = 'Add a room below, then click "Save"';
    } else if (isLeadPresent === 'no') {
      noRoomsText = 'Click "ADD" to start adding rooms';
    }

    return (<div>
      <h6>LRRP Info</h6>
      {!this.props.leadCertNumber ? (<h4>
        You must have a lead cert number to complete this task
        </h4>) : (<span>
          <RadioButtons
            onChange={this.handleIsLeadPresent}
            selectedValue={isLeadPresent}
            radioButtons={buttons}
            text="Are lead safe practices needed?"
          />
          {!noRooms ? (<table className={S.table}>
            <thead>
              <tr className={S.headerRow}>
                <th className={S.cell}>Room</th>
                <th className={S.deleteCell}>Delete</th>
              </tr>
            </thead>
            <tbody>
              {rooms.map((room, index) =>
                <tr className={S.contentRow} key={room}>
                  <td className={S.cell}>{room}</td>
                  <td className={S.deleteCell}>
                    <IconButton
                      icon="delete"
                      onClick={this.handleDelete(index)}
                    />
                  </td>
                </tr>,
              )}
            </tbody>
          </table>) : (<div className={S.emptyTable}>
            <h4>{noRoomsText}</h4>
          </div>)}
          {addRoom && <form onSubmit={this.handleSaveRoom}>
            <SimpleInput
              label="Room"
              text={newRoom}
              onChange={this.handleNewRoom}
            />
            <input className={S.save} type="submit" value="Save" />
          </form>}
          {isLeadPresent === 'no' && <span>
            <Button
              className={addRoom ? S.cancel : S.add}
              label={addRoom ? 'Cancel' : 'Add'}
              flat inverse ripple
              onClick={this.handleAddRoom}
            />
            <Button
              label="Next"
              flat inverse ripple
              disabled={noRooms}
              className={S.submit}
              onClick={this.handleSubmit}
            />
          </span>}
        </span>)}
    </div>);
  }
}

LrrpInfo.propTypes = {
  isLeadPresent: PropTypes.string,
  leadCertNumber: PropTypes.string,
  rooms: PropTypes.array,
  errors: PropTypes.shape({
    isLeadPresent: PropTypes.arrayOf(PropTypes.string),
    rooms: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default connect(state => ({ errors: getPhaseErrors(state) }), {
})(LrrpInfo);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/SignLrrpModal/lrrp_info.jsx